module.exports = __webpack_public_path__ + "static/Gartner_logo-f688cc222ee58012f307c8d23d9b7593.png";